<div class="video-preview-container">
  <div #videoWrapperEl class="video-preview-content-inner" [style.width.%]="(player.playerData.ratio / (16 / 9)) * 100">
    @if (thumbUrl) {
      <img [src]="thumbUrl" alt="capture" />
    }
  </div>
</div>
@if (isSeeking && !player.playerData.screenshotUrl) {
  <div class="spinner">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
}
